//maintaining the routes for the whole application

export class RouteConstants {
  public static routes= {
    home: "/home",
    homeNew: "/home-new",
    login: "/login",
    main:"/",
    emailVerification:'/emailVerification',
    footer: '/footer',
    courses:'courses',
    institutes:'/institutes',
    loanDetails: "/loan-details",
    studentDetails: "/student-details",
    kycDetails: "/kyc-details",
    pan: "/kyc-details/pan",
    basicDetails: "/kyc-details/basic-details",
    employmentDetails: "/kyc-details/employment-details",
    proofVerification: "/kyc-details",
    bankDetails: "/kyc-details/bank-details",
    aadharDetails: "/kyc-details/aadhar-details",
    selfie: "/kyc-details/selfie",
    keyFactStatement: "/key-fact-statement",
    applicationLetter: "/application-letter",
    nachMandate: "/nach-mandate",
    welcome: "/welcome",
    moratorium: "/moratorium",
    insurance: "/insurance",
    grievanceRedressal: "/grievance-redressal",
    privacy: "/privacy",
    faq: "/faq",
    contactUs: "/contact-us",
    emiCalculator: "/emi-calculator",
    eligibility: "/eligibility",
    processingFee: "/processing-fee",
    noResults: "/no-results",
  }
}
